<template>
  <div v-if="programArticle" class="
      shadow-md
      bg-white
      rounded-[20px]
flex-col flex gap-4
w-full"
  >
    <div class="flex flex-row justify-between items-center rounded-t-[20px]"
         :class="[highlightColor === 'blue' ? 'bg-[#2699C6]' : 'bg-brand-orange']">
      <p class="font-bold text-white text-[24px] self-stretch py-[10px] px-[20px]" style="line-height: 24px">
        {{ this.programArticle.start }} – {{ this.programArticle.end }}</p>
      <button
        class="h-full px-4 py-[6px] rounded-full bg-white inline-flex gap-2 mr-4 justify-center items-center text-center"
        :class="[highlightColor === 'blue' ? 'text-brand-blue' : 'text-brand-orange']" @click.prevent="action">
        Zobrazit více
        <svg v-if="highlightColor === 'orange'" xmlns="http://www.w3.org/2000/svg" width="10" height="9"
             viewBox="0 0 10 9" fill="none">
          <path d="M8.94531 4.68398L1.33374 4.68398M8.94531 4.68398L5.68321 1.42187M8.94531 4.68398L5.68321 7.94608"
                stroke="#F6A02C" stroke-width="1.48563" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-if="highlightColor === 'blue'" xmlns="http://www.w3.org/2000/svg" width="10" height="9"
             viewBox="0 0 10 9" fill="none">
          <path d="M8.5 4.99257L0.888426 4.99257M8.5 4.99257L5.2379 1.73047M8.5 4.99257L5.2379 8.25467" stroke="#2699C6"
                stroke-width="1.48563" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div class="flex flex-row mb-4 ml-4">
      <img
        v-if="programArticle.speaker.photo_url"
        class="object-cover rounded-full w-[90px] h-[90px] mr-4"
        :src="programArticle.speaker.photo_url"
        style="aspect-ratio: 1/1"
        :alt="'Profilová fotografie: ' + programArticle.speaker.name"
      />
      <div class="flex flex-col gap-[6px] justify-center">
        <p class="uppercase text-[14px]" style="line-height: normal"
           :class="[highlightColor === 'blue' ? 'text-brand-blue' : 'text-brand-orange']">
          {{ programArticle.speaker.name }}
        </p>
        <p class="text-[18px] mr-4" style="line-height: normal">{{ truncatedText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import RadioButton from "../Atomic/Radio.vue";
import {useWindowSize} from "@vueuse/core";
import {computed} from "vue";

export default {
  emits: [
    "clicked",
    "update:timeslotSelections",
    "unRegisterWorkshop",
    "registerWorkshop",
  ],

  components: {
    RadioButton,
  },
  setup() {
    const { width } = useWindowSize();
    const cardWidth = computed(() => `${width.value - 40}px`);
    return {
      cardWidth,
    };
  },
  data() {
    return {
    }
  },
  props: {
    programArticle: {
      type: Object,
    },

    enableMoreInfo: {
      type: Boolean,
      default: true,
    },

    isWorkshop: {
      type: Boolean,
      default: false,
    },

    userLoggedIn: {
      type: Boolean,
      default: false,
    },

    workshopRegistrationState: {
      type: Object,
      default: undefined,
    },

    maxWorkshopRegistrationsPerUser: {
      type: Number,
      default: undefined,
    },

    registerGroupsCheck: {
      type: Boolean,
      default: false,
    },

    timeslotSelections: {
      type: Object,
      default: undefined,
    },

    hasHappeningSiblingUp: {
      type: Boolean,
      default: false,
    },

    hasHappeningSiblingDown: {
      type: Boolean,
      default: false,
    },

    workshopRegistrationOpened: {
      type: Boolean,
      default: false,
    },
    highlightColor: {
      type: String,
      default: 'orange'
    }
  },

  methods: {
    action() {
      this.$emit("clicked", {
        ...this.programArticle,
        time: this.talkTime(),
        userAssignedToWorkshop: this.userAlreadyRegisteredToWorkshop,
        isMastermind: true,
      });
    },
    talkTime() {
      if (this.programArticle.start === undefined) {
        return "Čas přednášky";
      }

      return this.programArticle.start + "–" + this.programArticle.end;
    },

    registerWorkshop() {
      this.$emit("registerWorkshop", this.programArticle.id);
    },

    unRegisterWorkshop() {
      this.$emit("unRegisterWorkshop", this.programArticle.id);
    },
  },

  computed: {
    truncatedText() {
      if(this.programArticle.title.length > 55) {
        return this.programArticle.title.substring(0, 55) + '...';
      } else {
        return this.programArticle.title
      }
    },
    userAlreadyRegisteredToWorkshop() {
      if (this.workshopRegistrationState !== undefined) {
        const el = this.workshopRegistrationState.user_registrations.find(
          (e) => e === this.programArticle.id
        );
        if (el) {
          return true;
        }
      }

      return false;
    },
  },
};
</script>

<style>
</style>
